// extracted by mini-css-extract-plugin
export default {"container":"f3fqZ","count":"Mrf-U"};